import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

// Async thunk to search cities by state ID
export const searchCities = createAsyncThunk(
  "cities/search",
  async ({ stateId, query = "", page = 0, size = 150 }, { rejectWithValue }) => {

    try {

      let url = `/authn/city/${stateId}/search?page=${page}&size=${size}`;

      if (query.trim() !== "") {
        url += `&q=${encodeURIComponent(query.trim())}`;
      }


      const response = await get(url, null, {
        skipAuth: false,
      });

      return Array.isArray(response) ? response : [];

    } catch (error) {

      console.error("City API error:", error);

      return rejectWithValue(
        error?.message || "Failed to fetch cities"
      );

    }

  }
)

const citiesSlice = createSlice({
  name: "cities",
  initialState: {
    cities: [],
    loading: false,
    error: null,
  },
  reducers: {

    clearCities: (state) => {
      state.cities = []
      state.error = null
    },

  },

  extraReducers: (builder) => {

    builder

      .addCase(searchCities.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(searchCities.fulfilled, (state, action) => {
        state.loading = false
        state.cities = action.payload || []
      })

      .addCase(searchCities.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

  },

})

export const { clearCities } = citiesSlice.actions

export default citiesSlice.reducer
